// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* our variables */\n[data-v-1863a09b] .v-list-item--link:before {\n  background-color: var(--msi-primary);\n}\n[data-v-1863a09b] .v-list-item__title {\n  z-index: 1;\n}\n[data-v-1863a09b] .v-image__image--contain {\n  top: 9px;\n  height: 60%;\n}\n[data-v-1863a09b] .v-list-item__icon:first-child {\n  margin-right: 12px;\n}", ""]);
// Exports
module.exports = exports;
